<template>
  <div class="detail">
    <div class="detail-header">
      <div class="detail-header-text">
        <h3>项目详情</h3>
        <p>随时随地为您提供智能的解决方案</p>
      </div>
    </div>
    <div class="detail-background">
      <div class="detail-content">  
        <div class="detail-content-top">
          <div class="detail-content-top-left">
            <img src="../assets/default.png" alt="">
            <span>{{ruleForm.creatorName}}</span>
          </div>
          
          <div class="detail-content-top-right">
            <h1>{{ruleForm.type == 1?'广告策划':ruleForm.type == 2?'企业咨询':ruleForm.type == 3?"数字内容制作":"系统平台搭建"}}</h1>
            <div class="text text3" >
              <h2>项目名称</h2><span>{{ruleForm.projectName}}</span>
            </div>
            <div class="text" >
              <h3>项目描述</h3><span>{{ruleForm.projectDescribe}}</span>
            </div>
            <div class="detail-content-top-right-flex text4" >
              <div class="text text2">
                <p>项目预算</p><span style="color:#F89A00">{{ruleForm.projectSpendStr}}</span>
              </div>
              <div class="text">
                <p>交付周期</p><span>{{ruleForm.expectDay}}天</span>
              </div>
            </div>
            <div class="detail-content-top-right-flex">
              <div class="text text2">
                <p>联系人</p><span>{{ruleForm.contacts}}</span>
              </div>
              <div class="text">
                <p>联系方式</p><span>{{ruleForm.contactPhone}}</span>
              </div>
            </div>
            <div class="text text5" >
              <h4>联系地址</h4><span>{{ruleForm.contactAdd}}</span>
            </div>
          </div>
        </div>
        <em v-if="ruleForm.proPicList.length > 0"></em>
        <div class="detail-content-imgList" v-if="ruleForm.proPicList.length > 0">
          <div class="detail-content-imgList-item" v-for="(item,index) in ruleForm.proPicList" :key="index">
            <img :src="item" alt="">
            <span class="mask">
              <img
                src="../assets/zoom.png"
                class="zoom"
                @click="previewUrl = item,previewDia = true"
              >	
            </span>      
          </div>
        </div>
        <div class="detail-content-send" @click="$router.go(-1)">返回</div>
      </div>

    </div>
    <el-dialog
      title=""
      custom-class="preview"
      :visible.sync="previewDia"
      width="800px"
    >
      <img :src="previewUrl" alt="" style="width:100%;height:100%">
  </el-dialog>
  </div>
</template>

<script>
import { getDetail } from "../utils/publish"
export default {
  name: 'topsubmit', 
  components: {
    
  },
  data(){
    return{
      ruleForm: {
        proPicList:[]
      },
      previewDia:false,
      previewUrl:"",
      rules: {
        type: [
          { required: true, message: '请选择项目类型', trigger: 'change' },
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        projectSpend: [
          { required: true, message: '请选择预算范围', trigger: 'change' },
        ],
        projectDescribe: [
          { required: true, message: '请输入项目描述', trigger: 'blur' },
        ],
        expectDay: [
          { required: true, message: '请输入期望交付周期', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        // leaveNote: [
        //   { required: true, message: '请输入留言', trigger: 'blur' },
        // ],
      },
      options:[
        {
          label:"3万以下",
          value:"1"
        },
        {
          label:"3万-10万",
          value:"2"
        },
        {
          label:"10万-50万",
          value:"3"
        },
        {
          label:"50万以上",
          value:"4"
        },
      ],
      options2:[
        {
          label:"广告策划",
          value:1
        },
        {
          label:"企业咨询",
          value:2
        },
        {
          label:"数字内容制作",
          value:3
        },
        {
          label:"系统平台搭建",
          value:4
        },
      ]
    }
  },
  methods:{
  },
  activated(){
    if(this.$route.query.id){
      getDetail({id:this.$route.query.id}).then(res => {
        // console.log("res",res)
        if(res.data.code == 200 ){
          this.$nextTick(()=>{
            this.ruleForm = res.data.data
            console.log('',this.ruleForm.proPicList);
          })
        }else{
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}
.detail{
  width:100%;
  &-header{
    width: 100%;
    height: 461px;
    background: url("../assets/detail.png") no-repeat;
    background-size: cover;
    display: flex;
    &-text{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-left: 190px;
      h3{
        .fontdemo(47px, 'PingFangSC,PingFang SC', 600, #000000);
        margin: 0;
        text-align: left;
      }
      p{
        .fontdemo(30px, 'PingFangSC,PingFang SC', 400, #000000);
        margin: 22px 0 49px;
        max-width: 700px;
        line-height: 50px;
        text-align: left;
      }
    }
  }
  &-background{
    width: 100%;
    background: url("../assets/cover.png") no-repeat;
    background-size: cover;
    padding: 80px 0;
  }
  &-content{
    width: 1500px;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 80px 121px;
    margin: -128px auto 0;
    z-index: 99;
    position: relative;
    &-top{
      display: flex;
      align-items: flex-start;
      &-left{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: -10px;
        img{
          width: 142px;
          height: 142px;
          margin-bottom: 10px
        }
        span{
          .fontdemo(22px, 'MFDianHei_Noncommercial, MFDianHei_Noncommercial', 600, #000000);
        }
      }
      &-right{
        text-align: left;
        margin-left: 100px;
        .text{
          display: flex;
          align-items: flex-start
        }
        .text2{
          width: 600px
        }
        .text3{
          margin: 60px 0 40px
        }
        .text4{
          margin: 40px 0 40px
        }
        .text5{
          margin: 40px 0 40px
        }
        span{
          .fontdemo(26px, 'AlibabaPuHuiTi_2_75_SemiBold', 400, rgba(0,0,0,0.75));
        }
        h1{
          .fontdemo(32px, 'AlibabaPuHuiTi_2_75_SemiBold', 600, #000000);
        }
        h2,h3,h4{
          .fontdemo(26px, 'AlibabaPuHuiTi_2_75_SemiBold', 600, #000000);
          min-width: 150px;
        }
        &-flex{
          display: flex;
          align-items: flex-start;
          p{
            .fontdemo(26px, 'AlibabaPuHuiTi_2_75_SemiBold', 600, #000000);
            min-width: 150px;
            margin: 0;
          }
        }
      }
    }
    em{
      width: 100%;
      height: 0px;
      border: 1px solid #E7E7E7;
      display: block;
      margin: 65px 0 35px;
    }
    &-imgList{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      &-item{
        width:24%;
        height: 175px;
        margin-right: 1.333%;
        margin-bottom: 20px;
        position: relative;
        img{
          width: 100%;
          height: 100%;
        }
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          justify-content: center;
          align-items: center;
          opacity: 0;
          font-size: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          transition: opacity .3s;
          width: 100%;
          height: 175px;
          display: flex;
          cursor: pointer;
          .zoom{
            width: 30px;
            height: 30px;
          }
        }
      }
      :nth-child(4n) {
        margin-right: 0;
      }
      &-item:hover .mask {
        opacity: 1;
      }
    }
    &-send{
      width: 230px;
      height: 60px;
      background: #4787F0;
      border-radius: 8px;
      margin: auto;
      .fontdemo(22px, 'PingFangSC, PingFang SC', 500, #FFFFFF);
      line-height: 60px;
      margin-top: 72px;
      cursor: pointer;
    }
  }
}
</style>
